/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Legal_Name_NfpInputs */

const en_label_legal_name_nfp = /** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered Organisation Name`)
};

const es_label_legal_name_nfp = /** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la Organización Registrada`)
};

const fr_label_legal_name_nfp = /** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l'organisation enregistrée`)
};

const de_label_legal_name_nfp = /** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der registrierten Organisation`)
};

const id_label_legal_name_nfp = /** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Organisasi Terdaftar`)
};

/** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */
const ja_label_legal_name_nfp = en_label_legal_name_nfp;

/** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */
const zh_label_legal_name_nfp = en_label_legal_name_nfp;

/** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */
const ar_label_legal_name_nfp = en_label_legal_name_nfp;

/** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */
const it_label_legal_name_nfp = en_label_legal_name_nfp;

/** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */
const ru_label_legal_name_nfp = en_label_legal_name_nfp;

/** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */
const pt_label_legal_name_nfp = en_label_legal_name_nfp;

/** @type {(inputs: Label_Legal_Name_NfpInputs) => LocalizedString} */
const ko_label_legal_name_nfp = en_label_legal_name_nfp;

/**
* | output |
* | --- |
* | "Registered Organisation Name" |
*
* @param {Label_Legal_Name_NfpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_legal_name_nfp = /** @type {((inputs?: Label_Legal_Name_NfpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Legal_Name_NfpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_legal_name_nfp(inputs)
	if (locale === "es") return es_label_legal_name_nfp(inputs)
	if (locale === "fr") return fr_label_legal_name_nfp(inputs)
	if (locale === "de") return de_label_legal_name_nfp(inputs)
	if (locale === "ja") return ja_label_legal_name_nfp(inputs)
	if (locale === "zh") return zh_label_legal_name_nfp(inputs)
	if (locale === "ar") return ar_label_legal_name_nfp(inputs)
	if (locale === "id") return id_label_legal_name_nfp(inputs)
	if (locale === "it") return it_label_legal_name_nfp(inputs)
	if (locale === "ru") return ru_label_legal_name_nfp(inputs)
	if (locale === "pt") return pt_label_legal_name_nfp(inputs)
	return ko_label_legal_name_nfp(inputs)
});